const Logo: React.FC = () =>
        <div
                style={{
                    backgroundImage: `url('${process.env.PUBLIC_URL}/static/img/logo.svg')`,
                }}
                className='flex items-end mx-2 pb-2 w-[200px] bg-no-repeat bg-contain bg-center'
        />

export default Logo